import { Component } from '@grafikr/components'
import Spacify from '@/lib/spacify'
import Tabify from '@/lib/Tabify'

export default Component(node => {
    /**
     * Spaces in richtext editor
     */
    const blocks = node.querySelectorAll('[data-textblock]')
    const spaces = new Spacify(blocks)

    /**
     * Tabs
     */
    const
        tabToggles = node.querySelectorAll('[data-tab-toggle]'),
        tabs = node.querySelectorAll('[data-tab]'),
        icons = node.querySelectorAll('svg.icon--close'),
        toggleTabs = new Tabify(tabToggles, tabs, icons)

    /**
     * Back to top
     */
    const button = node.querySelector('[data-to-top]')
    if (button) {
        button.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        })
    }
})